import { render, staticRenderFns } from "./Pause.vue?vue&type=template&id=1c4634ae&scoped=true"
import script from "./Pause.vue?vue&type=script&lang=js"
export * from "./Pause.vue?vue&type=script&lang=js"
import style0 from "./Pause.vue?vue&type=style&index=0&id=1c4634ae&prod&lang=scss&scoped=true"
import style1 from "./Pause.vue?vue&type=style&index=1&id=1c4634ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4634ae",
  null
  
)

export default component.exports